const body = document.body;
const drawer = document.querySelector("#drawer");
const openMenu = document.querySelector("#openMenu");
const closeMenu = document.querySelector("#closeMenu");
const drawerLinks = drawer ? drawer.querySelectorAll("a") : [];

function setMenu(open) {
  body.classList.toggle("menu-open", open);
  drawer?.setAttribute("aria-hidden", String(!open));
  openMenu?.setAttribute("aria-expanded", String(open));

  if (open) {
    closeMenu?.focus();
  } else if (document.activeElement === closeMenu) {
    openMenu?.focus();
  }
}

openMenu?.addEventListener("click", () => setMenu(true));
closeMenu?.addEventListener("click", () => setMenu(false));
drawerLinks.forEach((link) => link.addEventListener("click", () => setMenu(false)));
document.addEventListener("keydown", (event) => {
  if (event.key === "Escape" && body.classList.contains("menu-open")) setMenu(false);
});

const feedbackForm = document.querySelector("#feedbackForm");
const feedbackNote = document.querySelector("#feedbackNote");

feedbackForm?.addEventListener("submit", (event) => {
  event.preventDefault();

  const data = new FormData(feedbackForm);
  const email = String(data.get("email") || "").trim();
  const message = String(data.get("message") || "").trim();
  const recipient = feedbackForm.dataset.recipient || "support@fluxynara.com";

  if (!email || !message) {
    if (feedbackNote) feedbackNote.textContent = "Please add your email and message.";
    return;
  }

  const subject = encodeURIComponent("FLUXYNARA feedback");
  const body = encodeURIComponent(`Visitor email: ${email}\n\nMessage:\n${message}`);
  window.location.href = `mailto:${recipient}?subject=${subject}&body=${body}`;
  if (feedbackNote) feedbackNote.textContent = "Your email app will open with this message ready to send.";
});

document.querySelectorAll("[data-carousel]").forEach((carousel) => {
  const track = carousel.querySelector("[data-carousel-track]");
  const slides = Array.from(carousel.querySelectorAll("[data-carousel-slide]"));
  const previous = carousel.querySelector("[data-carousel-prev]");
  const next = carousel.querySelector("[data-carousel-next]");
  const current = carousel.querySelector("[data-carousel-current]");
  let index = 0;
  let touchStartX = 0;

  if (!track || slides.length < 2) return;

  function showSlide(nextIndex) {
    index = (nextIndex + slides.length) % slides.length;
    track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
    slides.forEach((slide, slideIndex) => {
      slide.setAttribute("aria-hidden", String(slideIndex !== index));
    });
    if (current) current.textContent = String(index + 1);
  }

  previous?.addEventListener("click", () => showSlide(index - 1));
  next?.addEventListener("click", () => showSlide(index + 1));

  carousel.addEventListener("keydown", (event) => {
    if (event.key === "ArrowLeft") showSlide(index - 1);
    if (event.key === "ArrowRight") showSlide(index + 1);
  });

  carousel.addEventListener("touchstart", (event) => {
    touchStartX = event.changedTouches[0]?.clientX || 0;
  }, { passive: true });

  carousel.addEventListener("touchend", (event) => {
    const touchEndX = event.changedTouches[0]?.clientX || 0;
    const distance = touchEndX - touchStartX;
    if (Math.abs(distance) < 45) return;
    showSlide(index + (distance < 0 ? 1 : -1));
  }, { passive: true });

  showSlide(0);
});
